import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import useSWR from 'swr';
import { APIDestination } from '../../../../../../typings/Destination.interface';
import { APISource } from '../../../../../../typings/Source.interface';
import { TeamMember } from '../../../../../../typings/TeamMember.interface';
import { APIWebhook } from '../../../../../../typings/Webhook.interface';
import APIMethodKeys from '../../../client/APIMethodKeys';
import { GlobalContext } from '../../contexts/GlobalContext';
import { DashboardContext } from '../../scenes/DashboardScene/DashboardContext';
import { BulkOperationFilters } from './types';
export interface BulkRetryRenderData {
  webhooks?: APIWebhook[];
  sources?: APISource[];
  destinations?: APIDestination[];
  team_members?: TeamMember[];
}
const useBulkRetryRenderData = query => {
  const $ = _c(30);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    team
  } = useContext(DashboardContext);
  let t0;
  if ($[0] !== query) {
    t0 = "webhook_id" in query && query.webhook_id && query.webhook_id?.length > 0 && APIMethodKeys.webhooks.list({
      id: query.webhook_id
    });
    $[0] = query;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== HookdeckAPI.webhooks || $[3] !== query.webhook_id) {
    t1 = () => HookdeckAPI.webhooks.list({
      id: query.webhook_id
    });
    $[2] = HookdeckAPI.webhooks;
    $[3] = query.webhook_id;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    data: webhooks
  } = useSWR(t0, t1);
  let t2;
  if ($[5] !== query.source_id) {
    t2 = query.source_id && query.source_id.length > 0 && APIMethodKeys.sources.list({
      id: query.source_id
    });
    $[5] = query.source_id;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== HookdeckAPI.sources || $[8] !== query.source_id) {
    t3 = () => HookdeckAPI.sources.list({
      id: query.source_id
    });
    $[7] = HookdeckAPI.sources;
    $[8] = query.source_id;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const {
    data: sources
  } = useSWR(t2, t3);
  let t4;
  if ($[10] !== query) {
    t4 = "destination_id" in query && query.destination_id && query.destination_id.length > 0 && APIMethodKeys.destinations.list({
      id: query.destination_id
    });
    $[10] = query;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== HookdeckAPI.destinations || $[13] !== query.destination_id) {
    t5 = () => HookdeckAPI.destinations.list({
      id: query.destination_id
    });
    $[12] = HookdeckAPI.destinations;
    $[13] = query.destination_id;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const {
    data: destinations
  } = useSWR(t4, t5);
  let t6;
  if ($[15] !== query || $[16] !== team) {
    t6 = "cli_user_id" in query && query.cli_user_id && query.cli_user_id.length > 0 && team && APIMethodKeys.teams.listMembers(team.id);
    $[15] = query;
    $[16] = team;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== HookdeckAPI.teams) {
    t7 = () => HookdeckAPI.teams.listMembers();
    $[18] = HookdeckAPI.teams;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== team) {
    t8 = {
      isPaused: () => !team
    };
    $[20] = team;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const {
    data: team_members
  } = useSWR(t6, t7, t8);
  const loading = query.source_id && query.source_id.length > 0 && !sources || "destination_id" in query && query.destination_id && query.destination_id.length > 0 && !destinations || "cli_user_id" in query && query.cli_user_id && query.cli_user_id.length > 0 && !team_members || "webhook_id" in query && query.webhook_id && query.webhook_id?.length > 0 && !webhooks || false;
  const t9 = webhooks?.models;
  const t10 = sources?.models;
  const t11 = destinations?.models;
  const t12 = team_members || undefined;
  let t13;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t9) {
    t13 = {
      webhooks: t9,
      sources: t10,
      destinations: t11,
      team_members: t12
    };
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== loading || $[28] !== t13) {
    t14 = {
      loading,
      data: t13
    };
    $[27] = loading;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
export default useBulkRetryRenderData;